module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/3L7X0QN1lq01mW7yrtUKp0-ca3d17ff2a64e788b419014b12054503.jpg";